export const TOOL_SELECTOR_ACTION_TYPES = {
  SELECT_TOOL_BUTTON: 'SELECT_TOOL_BUTTON',
  CLEAR_TOOL_SELECTION: 'CLEAR_TOOL_SELECTION',
};

export const TOOL_BUTTON_NAMES = {
  USERS: 'Users',
  REPORTS: 'Reports',
  SETTINGS: 'Settings',
  INVITES: 'Invites',
  HELP: 'Help',
  SHARED: 'Shared',
  CUSTOM_FIELDS: 'Custom Fields',
  FACS_WORKFLOW_MANAGER_LICENSES: 'FACS Workflow Manager Licenses',
};

export const MODAL_ACTION_CONSTANTS = {
  SHOWMODAL: 'SHOWMODAL',
  HIDEMODAL: 'HIDEMODAL',
  POSITION_MODAL: 'POSITION_MODAL',
};

export const MODAL_TYPE_CONSTANTS = {
  USERMODAL: 'USERMODAL',
  SHAREDMODAL: 'SHAREDMODAL',
};

export const USER_SORT = {
  SORT_BY_COLUMN: 'SORT_BY_COLUMN',
  CLEAR_SORT_BY_COLUMN: 'CLEAR_SORT_BY_COLUMN',
  COLUMN_SORT_CLICKS: 'COLUMN_SORT_CLICKS',
};

export const USER_FILTER = {
  FILTER_BY_STATUS: 'FILTER_BY_STATUS',
  CLEAR_FILTER_BY_STATUS: 'CLEAR_FILTER_BY_STATUS',
  FILTER_BY_VALUE: 'FILTER_BY_VALUE',
  CLEAR_FILTER_BY_VALUE: 'CLEAR_FILTER_BY_VALUE',
};

export const ROWS = {
  ROWS_SELECTED: 'ROWS_SELECTED',
  CLEAR_ROWS_SELECTED: 'CLEAR_ROWS_SELECTED',
};

export const INVITE_USERS = {
  CANNOT_INVITE_USER: 'CANNOT_INVITE_USER',
};

// ID of "select all" checkbox
export const MASTER_CHECKBOX_ID = 'master';
